import { BrowserRouter, Outlet, Routes, Route } from 'react-router-dom';
import Box from '@mui/material/Box';
import { TopAppBar } from './components';
import { HomePage, AuthCallbackPage, EmbedPage, SunriseTicketPage } from './pages';

/** App chrome. `/embed` renders outside this so the overlay has no top bar. */
function AppLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Top App Bar */}
      <TopAppBar />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: { xs: 0, sm: 10 }, // xs=0: AppBar is sticky on mobile; sm=80px: fixed AppBar offset on desktop
          bgcolor: 'background.default',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/embed" element={<EmbedPage />} />
        <Route element={<AppLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/sunrise/tickets/:ticketId" element={<SunriseTicketPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
